
























































































import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator'
import LayerWrapper from '@/orrm/wrapper/layer'
import { Phenomene } from '@/orrm/model/phenomene'
import { Thematique } from '@/orrm/model/thematique'

@Component({
  components: { VueSlider }
})
export default class LayerCard extends Vue {
  @Prop({ default: null })
  value: LayerWrapper | null

  @Prop({ default: () => [] })
  tags: string[]

  @Prop({ type: Boolean, default: false })
  readonly: boolean

  @Prop({ type: Boolean, default: false })
  ita: boolean

  @Prop({ type: Boolean, default: false })
  deletable: boolean

  @PropSync('isChecked', { default: false })
  checked: boolean

  layer: LayerWrapper | null = null
  settingsOpen = false

  get settingsAvailable (): boolean {
    return 'settings' in this.$slots
  }

  get color (): string {
    return this.ita ? 'orlando' : 'primary'
  }

  get thematics (): string {
    if (!this.layer) return ''
    return this.layer.model.getThematiques().map((t: Thematique) => t.name).join(', ')
  }

  get phenomenes (): Phenomene[] {
    if (!this.layer) return []
    return this.layer.model.getPhenomenes()
  }

  get visibilityMinFormatted () {
    if (this.layer && this.layer.model.resolutionMin) {
      return this.formatScale(this.layer.model.resolutionMin)
    }

    return ''
  }

  get visibilityMaxFormatted () {
    if (this.layer && this.layer.model.resolutionMax) {
      return this.formatScale(this.layer.model.resolutionMax)
    }

    return ''
  }

  formatScale (scale: number, near = false): string {
    let num = scale.toString().split('').reverse().join('')
    let result = ''
    const gapSize = 3

    while (num.length > 0) {
      result = `${result} ${num.substring(0, gapSize)}`
      num = num.substring(gapSize)
    }
    return `1/${near ? '~' : ''}${result.split('').reverse().join('')}`
  }

  @Watch('value', { immediate: true })
  onValueChanged () {
    this.layer = this.value
  }
}
